var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 1032.4-5 0.8v11.5l5-0.8z",
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 1046.7-5 1.3v3.5l5 0.9z",
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 1032.4v13l5-1.3v-10.9z",
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 1044.9-5 2.6v4.9l5-0.9z",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 1041.8-5 2.3v3.4l5.023-2z",
    fill: "#f39c12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.9499 1032.9 2.5031 9.2 0.547-0.2v-9.5z",
    fill: "#f39c12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.078 1032.4 2.422 10.8h2.5v-10z",
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 1032.4v10.3l2.5-0.3-2.422-10z",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.026 1041.3-5.026 0.7v4.2l5-0.5z",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 1033.2v8.2l5-1.4v-7.6z",
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 1042.4-5 2.4v7.6l5-0.9z",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 1044.8-4.997 0.7-0.003 6 5 0.9z",
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 1044.1-5 0.8v3.3l5-0.7z",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 1039-5 2.4v3.4l5-1.6z",
    fill: "#f39c12"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#c0392b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.4023 1035.8c0.3907-0.4 0.586-0.9 0.586-1.4 0-0.6-0.1953-1.1-0.586-1.5-0.3906-0.3-0.8619-0.5-1.414-0.5s-1.0235 0.2-1.4141 0.5c-0.3906 0.4-0.5859 0.9-0.5859 1.5 0 0.5 0.1953 1 0.5859 1.4s0.862 0.6 1.4141 0.6 1.0234-0.2 1.414-0.6m2.5857-1.4c0 0.5-0.086 1-0.258 1.4l-2.8433 6c-0.0833 0.2-0.2083 0.3-0.375 0.4-0.1614 0.1-0.3359 0.2-0.5234 0.2s-0.3646-0.1-0.5313-0.2c-0.1614-0.1-0.2812-0.2-0.3593-0.4l-2.8516-6c-0.1719-0.4-0.2578-0.9-0.2578-1.4 0-1.1 0.3906-2.1 1.1719-2.9 0.7812-0.7 1.7239-1.1 2.8281-1.1 1.1041 0 2.0469 0.4 2.8281 1.1 0.7816 0.8 1.1716 1.8 1.1716 2.9",
    fill: "#c0392b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.c1e33a7b401fa39db58534d1f205b96f.svg";
export { ForwardRef as ReactComponent };